import gql from 'graphql-tag';
import React, {ReactNode} from 'react';

import BenchlingQuery from 'graphql-client/BenchlingQuery';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';
import {assertIsAccessible, assertAllAccessible} from 'graphql-client/InaccessibleInfo';
import {
  TemplatePublishingVersionHistoryPanelQuery,
  TemplatePublishingVersionHistoryPanelQueryVariables,
} from 'template-collectibles/publishing-ui/graphql/__generated/TemplatePublishingVersionHistoryPanelQuery';
import {CenteredHorizontalThrobber} from 'ui-library/HorizontalThrobber';

import {PublishingRecordForVersionHistoryPanel} from './types';

export const TEMPLATE_PUBLISHING_VERSION_HISTORY_PANEL_QUERY = gql`
  query TemplatePublishingVersionHistoryPanelQuery($templateId: StrictString!)
  @skipAudit
  @engComponent(name: NOTEBOOK) {
    template(id: $templateId) {
      ... on TemplateNode {
        id
        ...PublishingRecordsForVersionHistoryPanelGraphQL
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
  ${getFragmentWrapper('PublishingRecordsForVersionHistoryPanel').fragment}
`;

export function TemplatePublishingVersionHistoryPanelBenchlingQuery({
  children,
  templateId,
}: {
  children: (publishingRecords: Array<PublishingRecordForVersionHistoryPanel>) => ReactNode;
  templateId: string;
}): JSX.Element {
  return (
    <BenchlingQuery<
      TemplatePublishingVersionHistoryPanelQuery,
      TemplatePublishingVersionHistoryPanelQueryVariables
    >
      query={TEMPLATE_PUBLISHING_VERSION_HISTORY_PANEL_QUERY}
      variables={{templateId}}
      renderLoading={() => <CenteredHorizontalThrobber />}
    >
      {({template}) => {
        const accessibleTemplate = assertIsAccessible(template);
        const publishingRecords: Array<PublishingRecordForVersionHistoryPanel> = assertAllAccessible(
          accessibleTemplate.publishingRecords
        );
        return children(publishingRecords);
      }}
    </BenchlingQuery>
  );
}
